import React from 'react';
import { Input, Pagination, Select, Button } from 'components';
import { Constants } from 'utils';
import { NotificationService } from 'services';

interface Props {
  selected: any[];
  onConfirm: (users: any[]) => void;
  onClose: () => void;
}

class ModalCandidates extends React.Component<Props> {
  timer: any = undefined;

  state = {
    form: {
      search: '',
      level_id: Constants.LEVELS.CLIENT.toString(),
      verified: '',
    },
    page: 1,
    last_page: 1,
    candidates: [],
    selected: [...this.props.selected],
  };

  componentDidMount() {
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await NotificationService.admin.candidates({
      withoutLoading,
      page: this.state.page,
      level_id: Number(this.state.form.level_id),
      search: this.state.form.search,
      ...(this.state.form.level_id === Constants.LEVELS.LAWYER.toString() &&
      this.state.form.verified !== ''
        ? { verified: Number(this.state.form.verified) }
        : {}),
    });
    this.setState({
      // El endpoint responde { users: { rows, count } }, no { candidates: ... }.
      candidates: res.users?.rows ?? [],
      last_page: res.users?.count ?? 1,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  toggle = (item: any) => {
    const exists = this.state.selected.find((u: any) => u.id === item.id);
    this.setState({
      selected: exists
        ? this.state.selected.filter((u: any) => u.id !== item.id)
        : [...this.state.selected, item],
    });
  };

  confirm = () => {
    this.props.onConfirm(this.state.selected);
  };

  render() {
    const isLawyer = this.state.form.level_id === Constants.LEVELS.LAWYER.toString();

    return (
      <div id='modal-notification-candidates'>
        <div className='row'>
          <div className='col-md-4'>
            <Select
              color='white'
              label='Tipo'
              name='level_id'
              value={this.state.form.level_id}
              onChange={(e: any) => this.change(e, () => this.load(true))}
              options={[
                { value: Constants.LEVELS.CLIENT.toString(), label: 'Clientes' },
                { value: Constants.LEVELS.LAWYER.toString(), label: 'Abogados' },
              ]}
            />
          </div>
          <div className='col-md-4'>
            <Input
              value={this.state.form.search}
              name='search'
              placeholder='Nombre'
              label='Buscar'
              onChange={(e: any) => {
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                  this.load(true);
                }, 1000);
                this.change(e);
              }}
            />
          </div>
          {isLawyer && (
            <div className='col-md-4'>
              <Select
                color='white'
                label='Verificación'
                placeholder='Todos'
                name='verified'
                value={this.state.form.verified}
                onChange={(e: any) => this.change(e, () => this.load(true))}
                options={[
                  { value: Constants.VERIFIED.VERIFIED.toString(), label: 'Verificado' },
                  { value: Constants.VERIFIED.PENDING.toString(), label: 'Pendiente' },
                  { value: Constants.VERIFIED.IN_PROCESS.toString(), label: 'En proceso' },
                  { value: Constants.VERIFIED.REJECTED.toString(), label: 'Rechazado' },
                ]}
              />
            </div>
          )}
        </div>

        <div className='white-container'>
          {this.state.candidates.map((item: any) => {
            const checked = !!this.state.selected.find((u: any) => u.id === item.id);
            // La respuesta solo trae name/lastname/email (no full_name/full_document).
            const fullName = `${item.name || ''} ${item.lastname || ''}`.trim();
            return (
              <button
                key={item.id}
                type='button'
                className={`btn-lawyer ${checked ? 'active' : ''}`}
                onClick={() => this.toggle(item)}
              >
                <span>{fullName}</span>
                <span>{item.email}</span>
              </button>
            );
          })}
        </div>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({ page });
            this.load();
          }}
        />

        <div className='text-center' style={{ marginTop: 15 }}>
          <Button type='button' onClick={() => this.confirm()}>
            Confirmar ({this.state.selected.length})
          </Button>
        </div>
      </div>
    );
  }
}

export default ModalCandidates;
